"use strict";
class SizeFinder extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onClick.bind(this), false);
  }
  onClick(e) {
    if (e.target.closest("[data-sf-open]")) return this.open();
    if (e.target.closest("[data-sf-change]")) return this.open();
    const tab = e.target.closest("[data-sf-scale]");
    if (tab) return this.setScale(tab.getAttribute("data-sf-scale"));
    // Size chips and "See all sizes" are plain <a> links: they navigate to a
    // freshly filtered collection URL so the product cards carry ?variant= and
    // the product page pre-selects the chosen size. No JS needed for those.
  }
  open() {
    this.classList.remove("is-selected");
    this.classList.add("is-open");
  }
  setScale(scale) {
    this.classList.toggle("pds-show-w", scale === "w");
    this.classList.toggle("pds-show-m", scale === "m");
    this.classList.toggle("pds-show-eu", scale === "eu");
    this.querySelectorAll("[data-sf-scale]").forEach((t) => {
      const on = t.getAttribute("data-sf-scale") === scale;
      t.classList.toggle("is-active", on);
      t.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }
}
customElements.define("size-finder", SizeFinder);

/* Opens the size guide in the same tingle interstitial the product page uses.
   tingle is loaded site-wide; the content lives in a hidden div inside this el. */
class SizeGuidePopup extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onClick.bind(this), false);
  }
  onClick(e) {
    if (e.target.closest(".pds-size-finder__guide-content")) return;
    if (typeof tingle === "undefined") return;
    const content = this.querySelector(".pds-size-finder__guide-content");
    if (!content) return;
    const header = this.dataset.header || "Size guide";
    const modal = new tingle.modal({
      footer: false,
      stickyFooter: false,
      closeMethods: ["overlay", "button", "escape"],
      cssClass: ["size_chart", "pds-size-guide-modal"],
    });
    modal.setContent(
      '<div class="tingle-modal-box__header"><h3 class="title-popup h5 my-0 px-20 px-md-30 py-20 border-bottom">' +
        header +
        "</h3></div>" +
        content.innerHTML
    );
    modal.open();
  }
}
customElements.define("size-guide-popup", SizeGuidePopup);
